import useIsBrowser from 'hooks/useIsBrowser'

const useIsPartnersPage = () =>
  useIsBrowser &&
  (window.location.href.includes('/partners') ||
    window.location.href.includes('/technology')) &&
  window.location.hash

export default useIsPartnersPage
